<template>
  <div class="dialog-container wt-dialog-container">
    <div v-loading="isInformationDetailLoading">
      <wt-detail-form-section ref="formSection" :detail-form-data.sync="detailFormData" :detail-form.sync="detailForm" :readonly="true" />
      <wt-detail-form-buttons :detail-form-buttons.sync="detailFormButtons" @on-detail-button-action="onDetailButtonAction"></wt-detail-form-buttons>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'InfoEprotectionView',
  props: ['component-type'],
  isAutoComponent: true,
  data() {
    return {
      formCode: 'MODULES_GOODSTYPE',
      isSubmitLoading: false,
      detailFormButtons: {
        title: '详情',
        elements: [{ name: '返回', key: 'CLOSE', action: 'CLOSE' }]
      },
      detailForm: {
        title: '基本信息',
        elements: [
          { name: '资讯标题', key: 'title', type: 'text', disabled: false, className: 'wt-col-12' },
          { name: '资讯标签', key: 'typeName', type: 'text', disabled: false, className: 'wt-col-12' },
          { name: '资讯封面', key: 'coverPathList', type: 'image', disabled: false, className: 'wt-col-12' },
          { name: '资讯内容', key: 'content', type: 'editor', disabled: false, className: 'wt-col-12' }]
      }
    }
  },
  created() {
    this.detailFormData.coverPathList = [{ fileUrl: this.detailFormData.coverPath }]
  },
  methods: {
    /*  ------------------------- 按钮  -------------------------  */
    onDetailButtonAction(item) {
      if (item.action === 'CLOSE') {
        this.$emit('on-dialog-action', 'close')
      }
    },
    /*  ------------------------- 网络请求  -------------------------  */
    onWtDialogClose() {
      this.$emit('on-dialog-action', 'close')
    }
  },
  computed: {
    ...mapState({
      isInformationDetailLoading: state => state.information.isInformationDetailLoading,
      detailFormData: state => state.information.informationDetailData
    })
  }
}
</script>

<style scoped>

</style>
